import { render, staticRenderFns } from "./InviteesList.vue?vue&type=template&id=22132b98&scoped=true"
import script from "./InviteesList.vue?vue&type=script&lang=js"
export * from "./InviteesList.vue?vue&type=script&lang=js"
import style0 from "./InviteesList.vue?vue&type=style&index=0&id=22132b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22132b98",
  null
  
)

export default component.exports